<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      label-width="68px"
    >
      <el-form-item label="关键字" prop="key">
        <el-input
          v-model="queryParams.condition.key"
          placeholder="请输入关键字"
          clearable
          style="width: 240px"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      v-loading="loading"
      :data="tableData"
      :row-style="{height: '63px'}"
      height="calc(100vh - 240px)"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      border
    >
      <el-table-column
        label="项目名称"
        align="center"
        prop="projectName"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="工单名称"
        align="center"
        prop="orderName"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="操作人"
        align="center"
        prop="operator"
        width="280"
      >
        <template slot-scope="scope">
          {{ scope.row.operator }} - {{ scope.row.operaDeptName }}
        </template>
      </el-table-column>
      <el-table-column
        label="工单操作环节"
        align="center"
        prop="orderOperaNode"
        width="150"
      >
        <template slot-scope="scope">
          {{ scope.row.orderOperaNode | WorkOrderFiltering }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="操作状态"
        align="center"
        prop="status"
        width="150"
      >
        <template slot-scope="scope">
          {{ scope.row.status == true ? "成功" : "失败" }}
        </template>
      </el-table-column> -->
      <el-table-column
        label="操作时间"
        align="center"
        prop="updateTime"
        width="170"
      class-name="cell-two-line">
        <template slot-scope="scope">
          {{ scope.row.updateTime |timestampToTime }}
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.limit"
      :pageSizes="[50, 100, 200, 500]"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { orderOperaLog } from "@/api/work/WorkOrderOperation";
export default {
  data() {
    return {
      tableData: [],
      // 总条数
      total: 0,
      // 遮罩层
      loading: false,
      // 非多个禁用
      multiple: true,
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {},
      queryParams: {
        condition: {
          key: "",
        },
        limit: 50,
        page: 1,
        orders: [
          {
            asc: true,
            column: "createTime",
          },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询用户列表 */
    async getList() {
      this.loading = true;
      let { data } = await orderOperaLog(this.queryParams);
      this.tableData = data.records;
      this.total = data.total;
      this.loading = false;
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.condition.key = undefined;
      this.getList();
    },
  },
};
</script>

<style scoped>
.demo-table-expand {
  font-size: 0;
  padding: 0 50px;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
::v-deep .el-form--inline .el-form-item__label {
  font-weight: 600;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>